import React, { Component } from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import UserAwards from "../Awards/UserAwards";


class Username extends Component {
    memberOrNot() {
        if (this.props.rank && this.props.user) {
            return (
                <div className="clearfix">
                    <img className="pull-left username-popover-image" src={this.props.rank.image} alt="" width="32px"
                         height="32px"/>
                    <div>{this.props.user.displayName}</div>
                    <div className="rank-title">{this.props.rank.title}</div>
                </div>
            )
        } else if (this.props.user) {
            return <div>{this.props.user.displayName}</div>
        } else { return null }
    }
    render() {
        const userPopover = (
            <Popover id="user-popover" title={this.memberOrNot()}>
                <UserAwards user={this.props.user} />
            </Popover>
        );
        if (this.props.user) {
            return (
                <OverlayTrigger trigger="click" rootClose placement={this.props.placement} overlay={userPopover}>
                <span className="adt-username">
                    {this.props.user.displayName}
                </span>
                </OverlayTrigger>
            );
        } else { return null }
    }
}

export default Username;


// WEBPACK FOOTER //
// ./src/common/Username.js